import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {BunkerLicense} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-selection-license',
    templateUrl: './selection-bunker-license.component.html',
    styleUrls: ['./selection-bunker-license.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectionBunkerLicenseComponent {

  @Input()
  selection: BunkerLicense;

}
